import React from "react";
import { Star } from "lucide-react";
import { REVIEWS, SITE } from "@/lib/site";

export const Reviews = () => {
  const half = Math.ceil(REVIEWS.length / 2);
  const row1 = REVIEWS.slice(0, half);
  const row2 = REVIEWS.slice(half);

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-20 md:py-32 bg-white scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
              Social proof
            </p>
            <h2 className="font-display mt-3 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
              Ohio trusts <span className="text-blue-600">ClearView.</span>
            </h2>
          </div>

          <div
            data-testid="rating-summary"
            className="flex items-center gap-4 bg-slate-50 rounded-2xl px-5 py-4 border border-slate-200"
          >
            <div className="font-display text-5xl font-black text-slate-900 leading-none">
              {SITE.rating.toFixed(1)}
            </div>
            <div>
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-xs font-bold text-slate-600 mt-1">
                Based on {SITE.reviewCountLabel} Google reviews
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-5">
        <Marquee reviews={row1} reverse={false} />
        <Marquee reviews={row2} reverse={true} />
      </div>
    </section>
  );
};

const Marquee = ({ reviews, reverse }) => (
  <div className="relative overflow-hidden">
    <div
      className="flex gap-5 marquee-track"
      style={{
        animationDirection: reverse ? "reverse" : "normal",
        width: "max-content",
      }}
    >
      {[...reviews, ...reviews].map((r, i) => (
        <ReviewCard key={`${r.name}-${i}`} review={r} />
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent" />
  </div>
);

const ReviewCard = ({ review }) => (
  <div
    data-testid="review-card"
    className="shrink-0 w-[320px] md:w-[380px] bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-shadow"
  >
    <div className="flex items-center gap-3 mb-3">
      <div className="h-10 w-10 rounded-full bg-blue-600 text-white grid place-items-center font-bold text-sm">
        {review.initials}
      </div>
      <div>
        <p className="font-bold text-slate-900 text-sm">{review.name}</p>
        <p className="text-xs text-slate-500 font-medium">{review.city}</p>
      </div>
      <div className="ml-auto flex items-center gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" />
        ))}
      </div>
    </div>
    <p className="text-sm text-slate-700 leading-relaxed font-medium">
      "{review.text}"
    </p>
  </div>
);
